import { Accordion, Alert, Icon, Text } from "@oysterhr/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export const DailyResponsibilitiesPearlContent = () => {
  const { t } = useTranslation("knowledge_base/HiringAdvisor", {
    keyPrefix: "roleInformation.dailyResponsibilities",
  })
  const [openAccordion, setOpenAccordion] = useState(["example-1"])

  return (
    <div>
      <Text className="mb-8">{t("header")}</Text>
      <Accordion open={openAccordion} onChange={setOpenAccordion} allowMultiple>
        <Accordion.Item key="example-1" id="example-1">
          <Accordion.Button>{t("example1.header")}</Accordion.Button>
          <Accordion.Content>
            <div className="mb-6 flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-error-base" name="SmileySad" size="md" />
                {t("bad")}
              </div>
              <Alert variation="error">
                <Alert.Content>{t("example1.bad")}</Alert.Content>
              </Alert>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-success-base" name="Smiley" size="md" />
                {t("good")}
              </div>
              <Alert variation="success">
                <Alert.Content>{t("example1.good")}</Alert.Content>
              </Alert>
            </div>
          </Accordion.Content>
        </Accordion.Item>

        <Accordion.Item key="example-2" id="example-2">
          <Accordion.Button>{t("example2.header")}</Accordion.Button>
          <Accordion.Content>
            <div className="mb-6 flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-error-base" name="SmileySad" size="md" />
                {t("bad")}
              </div>
              <Alert variation="error">
                <Alert.Content>{t("example2.bad")}</Alert.Content>
              </Alert>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-success-base" name="Smiley" size="md" />
                {t("good")}
              </div>
              <Alert variation="success">
                <Alert.Content>{t("example2.good")}</Alert.Content>
              </Alert>
            </div>
          </Accordion.Content>
        </Accordion.Item>

        <Accordion.Item key="example-3" id="example-3">
          <Accordion.Button>{t("example3.header")}</Accordion.Button>
          <Accordion.Content>
            <div className="mb-6 flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-error-base" name="SmileySad" size="md" />
                {t("bad")}
              </div>
              <Alert variation="error">
                <Alert.Content>{t("example3.bad")}</Alert.Content>
              </Alert>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-1">
                <Icon className="text-success-base" name="Smiley" size="md" />
                {t("good")}
              </div>
              <Alert variation="success">
                <Alert.Content>{t("example3.good")}</Alert.Content>
              </Alert>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </div>
  )
}
